// Test IDs for "Assistente do Antonio"
export const APP = {
  themeToggle: "app-theme-toggle",
  logout: "app-logout",
};

export const NAV = {
  hub: "nav-hub",
  chat: "nav-chat",
  rotina: "nav-rotina",
};

export const HUB = {
  page: "hub-page",
  streak: "hub-streak",
  examCard: "hub-exam-card",
  flashcardsCard: "hub-flashcards-card",
  quizCard: "hub-quiz-card",
  conversationsCard: "hub-conversations-card",
  goChat: "hub-go-chat",
  goRotina: "hub-go-rotina",
};

export const CHAT = {
  page: "chat-page",
  newConversation: "chat-new-conversation",
  conversationItem: (id) => `chat-conversation-${id}`,
  messageInput: "chat-message-input",
  sendButton: "chat-send-button",
  messageBubble: (id) => `chat-message-${id}`,
  examBanner: "chat-exam-banner",
  examButton: "chat-exam-button",
  materialButton: "chat-material-button",
  quizButton: "chat-quiz-button",
  flashcardsButton: "chat-flashcards-button",
  focusButton: "chat-focus-button",
  examModal: "chat-exam-modal",
  examSubjectInput: "exam-subject-input",
  examTitleInput: "exam-title-input",
  examDateInput: "exam-date-input",
  examContentInput: "exam-content-input",
  examSaveButton: "exam-save-button",
  examClearButton: "exam-clear-button",
  quizModal: "chat-quiz-modal",
  quizGenerate: "quiz-generate-button",
  quizOption: (qid, opt) => `quiz-option-${qid}-${opt}`,
  quizSubmit: "quiz-submit-button",
  flashcardsModal: "chat-flashcards-modal",
  flashcardsGenerate: "flashcards-generate-button",
  flashcardAnswerInput: "flashcard-answer-input",
  flashcardCheckButton: "flashcard-check-button",
  flashcardNext: "flashcard-next-button",
  materialModal: "chat-material-modal",
  materialPdfInput: "material-pdf-input",
  materialImageInput: "material-image-input",
  conversationOptions: (id) => `chat-conversation-options-${id}`,
  conversationDelete: (id) => `chat-conversation-delete-${id}`,
  conversationPin: (id) => `chat-conversation-pin-${id}`,
};

export const ROTINA = {
  page: "rotina-page",
  addEvent: "rotina-add-event",
  event: (id) => `rotina-event-${id}`,
  eventTitleInput: "rotina-event-title",
  eventDaySelect: "rotina-event-day",
  eventStart: "rotina-event-start",
  eventEnd: "rotina-event-end",
  eventTypeSelect: "rotina-event-type",
  eventSave: "rotina-event-save",
  eventDelete: "rotina-event-delete",
};
